export default "__VITE_ASSET__6079ac7f__"